<template>

    <div class="outer-wrapper">

        <div class="card-row">

            <img src="../../../public/img/discoverCard.png" />
            <img src="../../../public/img/amcard.png" />
            <img src="../../../public/img/mscard.png" />
            <img src="../../../public/img/visa.png" />
        </div>

        <div class="payment-info-wrapper">

            <div class="payment-amount-wrapper">

                <p class="payment-title">Total</p>
                <p class="payment-total">${{ orderTotal }}</p>

            </div>
            <div class="payment-info-form">

                <div class="card-information-wrapper">

                    <div class="input-wrap" >

                        <p class="input-title">card number:</p>
                        <cleave placeholder="Enter Card Number" class="input-data" :options="{ creditCard: true }" v-model=" cardInfo.cardNumber "></cleave>
                    </div>
                    <div class="input-wrap" >

                        <p class="input-title">name:</p>
                        <input type="text" v-model=" cardInfo.name " class="input-data" autocomplete="cc-name" spellcheck="false" />
                    </div>
                    <div class="small-sizing-inputs">

                        <div class="input-wrap" >

                            <p class="input-title">exp month:</p>
                            <select v-model=" cardInfo.expMo " class="input-data">

                                <option v-for=" n in 12 " :key=" n "> {{ n }} </option>
                            </select>
                        </div>
                        <div class="input-wrap" >

                            <p class="input-title">exp year:</p>
                            <select v-model=" cardInfo.expYr " class="input-data">

                                <option v-for=" n in 12 " :key=" n "> {{ currentYear + n - 1 }} </option>
                            </select>
                        </div>
                    </div>
                    <div class="input-wrap" >

                        <p class="input-title">cvv:</p>
                        <input type="text" v-model=" cardInfo.cvv " class="input-data" />
                    </div>
                    <div class="input-wrap" >

                        <p class="input-title">address:</p>
                        <input type="text" v-model=" cardInfo.address " class="input-data" autocomplete="shipping street-address" />
                    </div>
                    <div class="input-wrap" >

                        <p class="input-title">city:</p>
                        <input type="text" v-model=" cardInfo.city " class="input-data" autocomplete="shipping locality" />
                    </div>
                    <div class="small-sizing-inputs">

                        <div class="input-wrap" >

                            <p class="input-title">state:</p>
                            <select v-model=" cardInfo.state " class="input-data" autocomplete="shipping region">

                                <option v-for=" ( state, stateKey ) in unitedStates " :key=" stateKey " :value=" stateKey ">{{ state }}</option>
                            </select>
                        </div>
                        <div class="input-wrap">

                            <p class="input-title">zip:</p>
                            <input type="number" v-model=" cardInfo.zip " class="input-data" autocomplete="shipping postal-code"/>
                        </div>
                    </div>
                </div>
            </div>

            <OrderError />

            <div class="pay-button-wrapper">

                <button class="button btn-aqua" type="button" :disabled=" !formValid " @click=" submitOrder() ">

                    <font-awesome-icon class="lock-icon" v-if=" formValid " icon="lock-open"/>
                    <font-awesome-icon class="lock-icon" v-else icon="lock"/>
                    Pay ${{ orderTotal }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>

    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
    import Cleave from 'vue-cleave';
    import OrderError from '../misc/OrderError';
    import { mapGetters } from 'vuex';

    export default {

        name: 'payment',
        data: function(){

            return {

                cardInfo: {

                    cardNumber : '',
                    name       : '',
                    expMo      : '',
                    expYr      : '',
                    cvv        : '',
                    address    : '',
                    city       : '',
                    state      : '',
                    zip        : ''
                }
            }
        },
        methods: {

            submitOrder(){

                if( this.formValid && !this.isLoading ){

                    const formattedData = {

                        'card'     : process.env.VUE_APP_DEV_CARD || this.cardInfo.cardNumber.replace( /\s/g, "" ),
                        'expYear'  : this.cardInfo.expYr,
                        'expMonth' : this.cardInfo.expMo,
                        'code'     : this.cardInfo.cvv,
                        'name'     : this.cardInfo.name,
                        'city'     : this.cardInfo.city,
                        'state'    : this.cardInfo.state,
                        'zip'      : this.cardInfo.zip
                    };

                    this.$store.dispatch( 'orderTab/processPaymentInfo', formattedData )
                        .then( ( encryptedData ) => {

                            if ( encryptedData ) {

                                console.log( 'Encrypted Data: ', encryptedData );
                                // also passing in saveCard to signal if we should save the card information
                                this.$store.dispatch( 'orderTab/submitOrder', encryptedData );
                            } else {

                                this.$store.commit( 'orderTab/orderError', 'Unexpected error processing your card, please check your information' );
                            }
                        })
                }
            }
        },
        computed: {

            ...mapGetters({

                unitedStates : 'unitedStates',
                orderTotal   : 'orderTab/orderTotal',
                orderError   : 'orderTab/orderError',
                isLoading    : 'isLoading'
            }),
            formValid(){

                if( [ null, '' ].includes( this.cardInfo.cardNumber ) || ![ 15, 16 ].includes( this.cardInfo.cardNumber.replace( /\s/g, "" ).length ) ) return false;
                if( [ null, '' ].includes( this.cardInfo.name       ) ) return false;
                if( [ null, '' ].includes( this.cardInfo.expMo      ) ) return false;
                if( [ null, '' ].includes( this.cardInfo.expYr      ) ) return false;
                if( [ null, '' ].includes( this.cardInfo.cvv        ) || ![ 3, 4 ].includes( this.cardInfo.cvv.length ) || this.cardInfo.cvv.match( /[a-z]/i ) ) return false;
                if( [ null, '' ].includes( this.cardInfo.address    ) ) return false;
                if( [ null, '' ].includes( this.cardInfo.city       ) ) return false;
                if( [ null, '' ].includes( this.cardInfo.state      ) || this.cardInfo.state.length > 2 ) return false;
                if( [ null, '' ].includes( this.cardInfo.zip        ) || ![ 5 ].includes( this.cardInfo.zip.length ) ) return false;
                return true;
            },
            currentYear : () => new Date().getFullYear()
        },
        components: {

            FontAwesomeIcon,
            Cleave,
            OrderError
        }
    }
</script>

<style scoped>

    .card-row {

        display: flex;
        justify-content: space-between;
        align-items: center;

        padding: 20px 30px 0px;
        max-width: 800px;
        margin: 0px auto;
    }
    .card-row > img {

        width: 22%;
    }

    .payment-amount-wrapper {

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 115px;
    }
    .payment-title{

        font-size: 22px;
    }
    .payment-total{

        font-weight: bold;
        font-size: 30px;
    }

    .card-information-wrapper {

        margin: 0px 0px 15px;
        padding: 0px 15px;
    }

    .input-title {

        font-size: 18px;
    }
    .input-data {

        width: 100%;
        margin: 3px 1px;
        height: 45px;
        border-radius: 8px;
        border: 1px solid #ccc;
        padding: 0px 10px;
        font-size: 18px;
        transition: all 0.2s ease-in;
    }
    .input-data:focus {

        outline: none;
        border: 1px solid blue;
        box-shadow: 0px 2px 20px -5px blue;
    }
    .input-data::-webkit-input-placeholder {

        text-align: center;
    }

    .small-sizing-inputs {

        display: flex;
        justify-content: space-between;
    }
    .small-sizing-inputs > .input-wrap {

        width: 100%;
    }
    .small-sizing-inputs > .input-wrap:nth-child( 1 ) > .input-data {

        border-radius: 0;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        font-size: 14px;
    }
    .small-sizing-inputs > .input-wrap:nth-child( 2 ) > .input-data {

        border-radius: 0;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
    }


    .pay-button-wrapper {

        padding: 0px 15px;
        margin-bottom: 15px;
    }
    .pay-button-wrapper > button {

        width: 100%;
        height: 50px;
        font-size: 18px;
    }

    .lock-icon {

        width: 25px;
    }

</style>
